module.exports = __webpack_public_path__ + "img/title.de515342.png";